import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-3xmbsq-0"
})(["align-items:", ";display:flex;flex-direction:", ";flex-wrap:wrap;"], function (_ref) {
  var isRow = _ref.isRow;
  return isRow ? 'center' : 'flex-start';
}, function (_ref2) {
  var isRow = _ref2.isRow;
  return isRow ? 'row' : 'column';
});
export default Container;